import { render, staticRenderFns } from "./DetalleMulta.vue?vue&type=template&id=1a1fb52a&"
import script from "./DetalleMulta.vue?vue&type=script&lang=js&"
export * from "./DetalleMulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports